enum InsuranceProductType {
  GHEST_HAGH_BIMEH = 0,
  BIMEH_SHAKHS_SALES = 1,
  BIMEH_BADANEH = 2,
  BIMEH_DAFTARCHEH_HADESEH_ENFERADI = 3,
  BIMEH_ATASHSOOZI_MASKOONI = 4,
  BIMEH_MOSAFERATI = 5,
  BIMEH_HADESEH_ENFERADI = 6,
  BIMEH_MASOOLIAT_MADANI_OMUMI = 7,
  BIMEH_LIFE_PREMIUM_INSTALLMENT = 8,
  BIMEH_LIFE_LOAN = 9,
  BIMEH_LIFE = 10,
  BIMEH_DARMAN = 11,
  BIMEH_SHAKHS_SALES_ELHAGHIYEH = 12,
}

export default InsuranceProductType;
